import request from '@/utils/request';

/**
 * 课程记录
 * @param params
 * @returns {Promise<void>}
 */
export async function getCourseLog(params) {
  return request('/api/zeyin_school/app/member/courseLog', { params });
}


/**
 * 浏览记录
 * @param params
 * @returns {Promise<void>}
 */
export async function getBrowseLog(params) {
  return request('/api/zeyin_school/app/member/browseLog', { params });
}


/**
 * 已兑课程
 * @param params
 * @returns {Promise<void>}
 */
export async function getConvertCourseLog(params) {
  return request('/api/zeyin_school/app/member/convertCourseLog', { params });
}

/**
 * 收藏记录
 * @param params
 * @returns {Promise<void>}
 */
export async function getCollectLog(params) {
  return request('/api/zeyin_school/app/member/collectLog', { params });
}

/**
 * 我的积分
 * @param params
 * @returns {Promise<void>}
 */
export async function getMyPoints(params) {
  return request('/api/zeyin_school/app/member/getMemberPowerLogList', { params });
}



/**
 * 我的果实
 * @param params
 * @returns {Promise<void>}
 */
export async function getMyFiruit(params) {
  return request('/api/zeyin_school/app/member/getMemberFruitLogList', { params });
}

/**
 * 我的信息
 * @param params
 * @returns {Promise<void>}
 */
export async function getUserInfo(params) {
  return request('/api/zeyin_school/app/member/refreshUserInfo', { params });
}

/**
 * 获取当日积分状态
 * @param params
 * @returns {Promise<void>}
 */
export async function checkPointStatus(params) {
  return request('/api/zeyin_school/app/member/today/powerLog', { params });
}

/**
 * 我的等级
 * @param params
 * @returns {Promise<void>}
 */
export async function getUserLevel(params) {
  return request('/api/zeyin_school/app/member/getLevel', { params });
}


/**
 * 系统通知
 * @param params
 * @returns {Promise<void>}
 */
export async function getMessageList(params) {
  return request('/api/zeyin_school/app/member/getMessage', { params });
}



/**
 * 系统通知已读
 * @param params
 * @returns {Promise<void>}
 */
export async function messageRead(params) {
  return request('/api/zeyin_school/app/member/messageRead', { params });
}



/**
 * 回复我的
 * @param params
 * @returns {Promise<void>}
 */
export async function replyMeLog(params) {
  return request('/api/zeyin_school/app/member/replyMeLog', { params });
}

/**
 * 点赞我的
 * @param params
 * @returns {Promise<void>}
 */
export async function likeMeLog(params) {
  return request('/api/zeyin_school/app/member/likeMeLog', { params });
}


/**
 * 我评论的
 * @param params
 * @returns {Promise<void>}
 */
export async function myCommentLog(params) {
  return request('/api/zeyin_school/app/member/myCommentLog', { params });
}



/**
 * 课程会员
 * @param params
 * @returns {Promise<void>}
 */
export async function getCoursePrivilege(params) {
  return request('/api/zeyin_school/app/member/getCoursePrivilege', { params });
}

/**
 * 用户分享打开记录
 * @param params
 * @returns {Promise<void>}
 */
export async function postMemberShareLog(params) {
  return request('/api/zeyin_school/app/memberShare/', {
    method: 'POST',
    params
  });
}

/**
 * 发送验证码
 * @param params
 * @returns {Promise<any>}
 */
export async function getSendCode(params) {
  return request('/api/zeyin_school/app/member/sendCode', { params });
}

/**
 * 校验验证码
 * @param params
 * @returns {Promise<any>}
 */
export async function queryCheckCode(params) {
  return request('/api/zeyin_school/app/member/checkCode', { params });
}

/**
 * 绑定幸福卡
 * @param params
 * @returns {Promise<any>}
 */
export async function postBindCard(params) {
  return request('/api/zeyin_school/app/member/bindCard', {
    params,
    method: 'POST',
  });
}

export async function queryOfficeList(params) {
  return request('/zeyin_crm/college/h5/offices.do', { params });
}

export async function queryUserList(params) {
  return request('/zeyin_crm/college/h5/users.do', { params});
}

/**
 * 获取电子卡列表
 * @param params
 * @returns {Promise<any>}
 */
export async function queryCardList(params) {
  return request('/api/zeyin_school/app/member/listCardNumber', { params });
}

export async function queryRankList(params) {
  return request('/api/zeyin_school/app/member/getPointsBonusRanking', { params });
}

